<template>
  <div class="main shadow" id="home">
    <div class="menu" :style="{visibility: $route.path == '/' || $route.path == '/block0' ? 'hidden' : 'visible'}">
      <div class="logo">
        <router-link to="/block0">
          <img src="./img/logo.png" alt />
        </router-link>
      </div>
      <div class="menulist">
        <div class="item">
          <img src="./img/nav-4.png" alt />
          <span><router-link to="/block1">主要功能</router-link></span>
        </div>

        <div class="item">
          <img src="./img/nav-5.png" alt />
          <span><router-link to="/block2">注册/登录</router-link></span>

        </div>
        <div class="item">
          <img src="./img/nav-6.png" alt />
          <span><router-link to="/block3">绑定车辆</router-link></span>
        </div>

        <div class="item">
          <img src="./img/nav-16.png" alt />
          <span>功能介绍</span>
          <div class="submenu">
            <router-link to="/block3a">APP首页</router-link>
            <router-link to="/block4">关于车辆</router-link>
            <router-link to="/block4a">车辆解锁</router-link>
            <router-link to="/block4b">设撤防</router-link>
            <router-link to="/block4c">寻车</router-link>
            <router-link to="/block5">车辆定位</router-link>
            <router-link to="/block6">车辆控制 </router-link>
            <router-link to="/block7">骑行统计</router-link>
          </div>
        </div>
        <div class="item">
          <img src="./img/nav-15.png" alt />
          <span><router-link to="/block8">车队</router-link></span>

        </div>
         <div class="item">
          <img src="./img/nav-14.png" alt />
          <span><router-link to="/block9">我的</router-link></span>
        </div>
        <div class="item">
          <img src="./img/nav-17.png" alt />
          <span><router-link to="/block10">常见问题</router-link></span>
        </div>
      </div>
    </div>

    <div class="content">
      <!-- 搜索 -->
      <form class="getsearch">
        <div class="searchinput">
          <input type="text" class="search" placeholder="   关键字搜索" />
          <div class="submit"></div>
        </div>
      </form>
      <!-- 搜索 -->
      <div class="menu">
        <div class="title">
          <div class="menubutton">
            <img src="./img/menubutton.png" />
          </div>
          <div>使用说明书</div>
          <div class="searchbutton">
            <img src="./img/menusearch.png" width="43" height="43" />
          </div>
        </div>
        <div class="getsearch" :style="{visibility: $route.path == '/' || $route.path == '/block0' ? 'hidden' : 'visible'}">
          <div class="searchcontent">
            <input type="text" value />
            <img src="./img/search-icon.png" alt class="leftsearch" />
            <img src="./img/delete-icon.png" alt class="rightsearch" />
            <div class="submit">搜索</div>
          </div>
        </div>
        <div class="menucontent">
          <div class="leftm">
            <div class="item" @click="toBlock(1)">
              <img src="./block0/img/phone-icon.png" alt />
              <span>主要功能</span>
            </div>
            <div class="item" @click="toBlock(2)">
              <img src="./block0/img/phone-icon.png" alt />
              <span>注册/登录</span>
            </div>
            <div class="item" @click="toBlock(3)">
              <img src="./block0/img/phone-icon.png" alt />
              <span>绑定车辆</span>
            </div>
            <div class="item">
              <img src="./block0/img/phone-icon.png" alt />
              <span>功能介绍</span>
            </div>
            <div class="item" @click="toBlock(8)">
              <img src="./block0/img/phone-icon.png" alt />
              <span>车队</span>
            </div>
            <div class="item" @click="toBlock(9)">
              <img src="./block0/img/phone-icon.png" alt />
              <span>我的</span>
            </div>
            <div class="item" @click="toBlock(10)">
              <img src="./block0/img/phone-icon.png" alt />
              <span>常见问题</span>
            </div>          
          </div>
          <div class="rightm">
            <div></div>
            <div></div>
            <div></div>
            <div class="submenu">
            <router-link to="/block3a">APP首页</router-link>
            <router-link to="/block4">关于车辆</router-link>
            <router-link to="/block4a">车辆解锁</router-link>
            <router-link to="/block4b">设撤防</router-link>
            <router-link to="/block4c">寻车</router-link>
            <router-link to="/block5">车辆定位</router-link>
            <router-link to="/block6">车辆控制 </router-link>
            <router-link to="/block7">骑行统计</router-link>
            </div>
            <div class="submenu"></div>
          </div>
        </div>
      </div>
      <div class="maincontent">
        <router-view />
      </div>
    </div>
  </div>
</template>
<script>
export default {
  mounted(){
    let self = this;
    $(".getsearch .submit").each(function(i, item){
      $(item).click(function(){
        let str = $(this).parent().find("input").val().replace(/ /g, "");
        if(str){
          self.$router.push({path:"/search",query:{search:str}});
        }
      })
    });
  },
  methods: {
    toBlock(bno) {
      $(".main .content .menu .menucontent").hide();
      $(".main .content .menu").removeClass("active");
      $(".main .content .maincontent").show();
      if(this.$route.path != "/block" + bno){ this.$router.push("/block" + bno); }
    }
  }
};
</script>
<style>
@import url(./css/yadea.css);
@import url(./css/layout.css);
@media screen and (max-width: 768px) {
  body div.main div.content > div.menu > div.menucontent > div.leftm {
    overflow-y: auto;
    background-image: url(./block0/img/phone-bg-1.jpg);
    background-size: cover;
  }
  body div.main div.content > div.menu > div.menucontent > div.leftm > div.item {
    height: 7.1428571429rem;
    line-height: 7.1428571429rem;
    font-size: 2rem;
    padding-left: 1.4285714286rem;
    color: #000;
  }
  body div.main div.content > div.menu > div.menucontent > div.leftm > div.item > img {
    vertical-align: middle;
    margin-right: 0.3571428571rem;
    width: 9px;
  }
  body div.main div.content > div.menu > div.menucontent > div.leftm > div.item.active {
    background-color: #ecf1f9;
  }
  body div.main div.content > div.menu > div.menucontent > div.rightm {
    overflow-y: auto;
    background-image: url(./block0/img/phone-bg-2.jpg);
    background-size: cover;
  }
}
</style>
